import React, { useEffect, useRef } from 'react';
import Weather from './Weather';
import { useUpdateEffect } from 'ahooks';
import useProps from '../_util/useProps';

export default (props) => {
    const {value, options = {}} = props;
    const { map } = useProps();
    const weather = useRef();

    useEffect(() => {
        weather.current = new Weather(map);

        if (value) {
            weather.current.setValue(value, options)
        }

        return () => {
            weather.current.remove();
        }
    }, [])

    useUpdateEffect(() => {
        weather.current.setValue(value, options)
    }, [value, JSON.stringify(options)])

    return (
        <></>
    );
}
